<template>
  <div>
    <router-link
        :to="`factor/${row.id}/details`"
        class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip">
      <span class="tooltip-text">جزئیات</span>
      <i class="fas fa-eye"></i>
    </router-link>
    <a v-if="!row.is_archived" type="button" v-on:click.prevent="archive_factor" class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip">
      <span class="tooltip-text">{{ $t('online-factor.archive') }}</span>
      <i class="fas fa-archive"></i>
    </a>
    <a v-else type="button" v-on:click.prevent="unarchive_factor" class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip">
      <span class="tooltip-text">{{ $t('online-factor.unarchive') }}</span>
      <i class="fa fa-trash-restore"></i>
    </a>
    <a type="button" @click="delete_factor(row)" class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip">
      <span class="tooltip-text">{{ $t('online-factor.erase') }}</span>
      <i class="fas fa-trash"></i>
    </a>
  </div>
</template>
<script>

import Vue from "vue";
import { onlineFactorService } from '@/common/shop.service'
import toastr from "toastr";



export default Vue.extend({
  data(){
    return{
      checkType:false
    }
  },
        props: {
            row: {
                required: true,
            },
            index: {
                required: true,
            },
            datatable: {
                required: true,
            }
        },
        computed : {
          toastr() {
            toastr.options = {
              closeButton: true,
              positionClass: "toast-bottom-center",
              preventDuplicates: true,
              rtl: false
            }

            return toastr
          }
        },
        methods:{
          archive_factor() {
            onlineFactorService.archiveFactor(this.row.id) .then((response) => {
              this.toastr.success(response.data.message)
              this.datatable.reload()
            }).catch(({response}) => {
              this.toastr.error(response.data.message)
            })
          },
          unarchive_factor() {
            onlineFactorService.unarchiveFactor(this.row.id) .then((response) => {
              this.toastr.success(response.data.message)
              this.datatable.reload()
            }).catch(({response}) => {
              this.toastr.error(response.data.message)
            })
          },
          delete_factor() {
              onlineFactorService.deleteFactor(this.row.id).then((response) => {
              this.toastr.success(response.data.message)
              this.datatable.reload()
            }).catch(({response}) => {
              this.toastr.error(response.data.message)
            })
          },
          statusChange(row){
            if(row.status === 1){
                 onlineFactorService.factorStatusDiactive(this.row.id).then(response=>{
                   this.toastr.success(response.data.message)
                  window.location.reload()
                }).catch(error=>{
                 throw new Error(error)
              })
            }
            if(row.status === 0){
               onlineFactorService.factorStatusActive(this.row.id).then(response=>{
                 this.toastr.success(response.data.message)
                  window.location.reload()
                }).catch(error=>{
                 throw new Error(error)
              })
            }
          }
        },
    })

</script>


<style>
.special-tooltip{
    position: relative;
    display: inline-block;
}
.special-tooltip .tooltip-text {
    visibility: hidden;
    background-color: #555;
    color: #fff;
    text-align: center;
    padding: 5px 10px;
    border-radius: 6px;
    position: absolute;
    z-index: 1;
    bottom: 125%;
    opacity: 0;
    transition: opacity 0.3s;
    min-width: 90px !important;
}
.special-tooltip .tooltip-text::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    /*margin-left: -5px;*/
    border-width: 5px;
    border-style: solid;
    border-color: #555 transparent transparent transparent;
}
.special-tooltip:hover .tooltip-text {
    visibility: visible;
    opacity: 1;
}
</style>
